<template>
  <div class="home">
    <!-- AppBar -->
    <v-app-bar color="teal lighten-3" dark clipped-left app class="no-print">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>{{
        $store.state.title ? $store.state.title : "スケジュール管理ログイン"
      }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- メインアバターチップ -->
      <v-chip class="ma-2" color="primary" text-color="white">
        <v-avatar v-if="$store.state.type === UserType.Office" left>
          <v-icon>mdi-account</v-icon>
        </v-avatar>
        <v-avatar v-else left class="blue darken-4">
          {{ $store.state.name.charAt(0) }}
        </v-avatar>
        {{ $store.state.name }}
      </v-chip>
    </v-app-bar>

    <!-- Drawer -->
    <v-navigation-drawer
      v-model="drawer"
      clipped
      absolute
      app
      fixed
      :temporary="$vuetify.breakpoint.mobile"
    >
      <ListMenu v-model="menus" />
    </v-navigation-drawer>

    <!-- Main -->
    <v-main>
      <v-container>
        <router-view />
      </v-container>
    </v-main>
    <!-- <div class="Page-Btn" @click="scrollTop">
      <i class="fa fa-chevron-up Page-Btn-Icon"></i>
    </div> -->
  </div>
</template>

<script>
// @ is an alias to /src
import Common from "@/mixins/common";
import ShowDialogs from "@/mixins/showDialogs";

import UserType from "@/commons/usertype";

import TmpLogin from "./dialogs/TemporaryLogin";

import menusWeb from "@/commons/menus";

import menusIpad from "@/commons/ipad/menus";

export default {
  name: "Home",
  mixins: [Common, ShowDialogs],
  components: {
    ListMenu: () => import("@/components/ListMenu")
  },
  data() {
    return {
      UserType,
      drawer: false,
      menus: []
    };
  },
  methods: {
    logout() {
      console.log("logout");
    },
    scrollTop: function() {
      window.scrollTo({
        top: 0,
        behavior: "instant"
      });
    },
    click(e) {
      console.log(e);
    },
    async tmpLogin() {
      console.log(this.$store);
      if (!this.$store.state.user.login) await this.$showDialog(TmpLogin);
      else if (await this.$confirm("ログアウトしますか？"))
        this.$store.commit("user/logout");
    }
  },
  created() {
    console.log("vuetify.breakpoint", this.$vuetify.breakpoint);
    console.log("menusWeb", menusWeb, "menusIpad", menusIpad);
    if (this.$vuetify.breakpoint.mobile) this.menus = menusIpad;
    else this.menus = menusWeb;
    console.log(
      "menus",
      this.menus,
      "menusWeb",
      menusWeb,
      "menusIpad",
      menusIpad
    );
  }
};
</script>

<style>
.Page-Btn {
  position: fixed;
  right: 5px;
  bottom: 50px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 50%;
  background: #5bc8ac;
}
.Page-Btn-Icon {
  color: #fff;
  font-size: 20px;
}

@media (max-width: 1903px) {
  .v-main .v-main__wrap .container {
    /* margin: 0 20px; */
    margin-right: 0;
    margin-left: 0;
  }
}

@media (min-width: 1264px) {
  .container {
    max-width: 100%;
  }
}

@media (max-width: 1264px) {
  .container {
    max-width: 100%;
  }
}

.v-main .v-main__wrap .container {
  max-width: 100%;
}
</style>
